import { functions, httpsCall } from "../../firebase/firebase";
import { Button } from "antd";

export default function useFunctions() {
  const addMessage = httpsCall(functions, "addMessage");
  const getDeliveryCost = httpsCall(functions, "getDeliveryCost");
  const getShopDetails = httpsCall(functions, "getShopDetails");

  function onSubmit() {
    // addMessage({ text: "hello suckers" }).then((result) => {
    //   console.log(result);
    //   alert("success");
    // });
    // getDeliveryCost({ region_id: "D2uFnCrLwmiXoqL6RIrx" }).then((result) => {
    //   console.log(result);
    // });
    // getShopDetails({ shop_id: "Vbmfh1Sb4sMmb9hVKls0" }).then((result) =>
    //   console.log(result)
    // );
  }

  const TriggerComponent = () => (
    <Button onClick={onSubmit}>Trigger Function</Button>
  );

  return { TriggerComponent };
}
